'use client';

import { useEffect, useState } from 'react';
import { ClipboardPaste } from 'lucide-react';
import { Button } from '#/components/ui/button';

/**
 * 클립보드 붙여넣기 버튼. /correct·/analyze·/tokenize 의 원문 입력창이 공유한다.
 *
 * 클립보드 읽기는 브라우저·권한 제약이 있어(파이어폭스 미지원 등) 지원될 때만
 * 버튼을 노출하고, 권한 요청은 클릭 순간에만 일어난다(#281, soft-ask 원칙).
 * 헤더 한 줄에 얹히는 자리라 기본 sm(h-8)보다 낮은 h-7 로 줄여 원문 제목이
 * 정하는 행 높이를 넘지 않게 한다.
 */
export default function PasteButton({
  onPaste
}: {
  onPaste: (clip: string) => void;
}) {
  const [canPaste, setCanPaste] = useState(false);
  useEffect(() => {
    setCanPaste(!!navigator.clipboard?.readText);
  }, []);

  if (!canPaste) return null;

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-7 gap-1.5 px-2.5 text-xs has-[>svg]:px-2"
      onClick={async () => {
        try {
          const clip = await navigator.clipboard.readText();
          if (clip.trim()) onPaste(clip);
        } catch {
          // 권한 거부·미지원 — 다시 묻지 않고 조용히 넘어간다
        }
      }}
    >
      <ClipboardPaste className="size-3.5" />
      클립보드 붙여넣기
    </Button>
  );
}
